import { useSelector } from "react-redux";

import { BaseState, getBooleanFeatureGateEnabled } from "@gamedev-web/gamedev-sdk-core";

import { FeatureFlag } from "./featureFlags";

/**
 * Returns whether the given feature flag is enabled.
 *
 * @example
 * const isOpenDev = useFeatureFlag(FeatureFlags.OpenDevEnabled);
 */
export const useFeatureFlag = (flag: FeatureFlag): boolean =>
  useSelector((state: BaseState) => getBooleanFeatureGateEnabled(state, flag));
